<template>
    <footer id="footer">
        <!-- <p>本站部分资源来源于网络，如有侵权，请联系本站删除</p> -->
        <div class="copy">&copy; 2025<a href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备20004700号-1</a></div>
        <div class="copy"><img src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" alt=""><a href="https://beian.mps.gov.cn/#/query/webSearch?code=51130302000221" rel="noreferrer" target="_blank">川公网安备51130302000221号</a></div>
    </footer>
</template>
<script>
export default {
    name: '',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    watch:{
        
    },
    methods: {
        
    }
}
</script>
<style lang="less">
#footer{
    padding: 30px 0;
    text-align: center;
    font-size: 12px;
    .copy{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    a{
        text-decoration: underline;
        margin: 0 10px;
    }
    img{
        width: 16px;
    }
}
</style>